import { Button, Col, Modal, Row, message } from 'antd';
import { LanguageContext } from 'contexts/LanguageContext';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import React, { useContext, useState } from 'react';
import MarketingCampaignModal from './CampaignModal';
import { CampaignNumbers, Number, NumberInfo } from 'interfaces/number';
import { FormattedMessage } from 'react-intl';

const { confirm } = Modal;

interface CampaignItemProps {
  number: Number;
  numberInfo: NumberInfo;
  campaign: CampaignNumbers;
}

function CampaignItem({ number, campaign, numberInfo }: CampaignItemProps) {
  const [isCampaignModalVisible, setIsCampaignModalVisible] = useState(false);
  const { dictionary } = useContext(LanguageContext);

  function handleCancelCampaign() {
    const { clearCampaignQueue, getListOfNumbers, getConnectedChannels, getListCampaigns } = number;

    confirm({
      title: dictionary.clear_campaign_queue + " '" + campaign.nickname + ' (' + campaign.number + ")'?",
      okText: dictionary.yes,
      okType: 'danger',
      cancelText: dictionary.not,
      async onOk() {
        await clearCampaignQueue(campaign.id, campaign.number)
          .then(() => {
            message.success(dictionary.clear_campaign_queue_success);
            getListOfNumbers();
            getConnectedChannels();
            getListCampaigns();
          })
          .catch((err: any) => {
            if (err.message) {
              message.error(err.message);
            } else {
              message.error(dictionary.clear_campaign_queue_error);
            }
          });
      },
    });
  }

  return (
    <>
      {isCampaignModalVisible && (
        <MarketingCampaignModal
          numberInfo={numberInfo}
          totalCampaigns={campaign.totalCampaigns}
          visible={isCampaignModalVisible}
          setVisible={setIsCampaignModalVisible}
          handleCancelCampaign={handleCancelCampaign}
        />
      )}
      <div style={{ backgroundColor: '#e8f9fe', padding: 12 }}>
        <Row>
          <Col
            span={6}
            style={{
              lineHeight: '32px',
            }}
          >
            {campaign.nickname || '-'}
          </Col>
          <Col span={6} style={{ lineHeight: '32px' }}>
            {campaign.number || ''}
          </Col>
          <Col span={6} style={{ lineHeight: '32px' }}>
            {campaign.totalCampaigns > 0 ? campaign.totalCampaigns : 'Não há campanhas em andamento'}
          </Col>
          <Col span={6} style={{ display: 'flex', justifyContent: 'end', lineHeight: '32px' }}>
            <Button onClick={() => setIsCampaignModalVisible(true)} type="primary">
              <FormattedMessage id="settings" />
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Bitrix24Consumer(NumberConsumer(CampaignItem));
